import React, { FC, useCallback, useRef } from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import _ from 'lodash';

interface Props extends SelectProps {
    hasMore?: boolean; // Add the new prop
    onInfiniteScrollOnNextMemoised?: Function; // called on inf scroller
    onVisibilityChange?: Function; //called when dropdown visibility changes
}

const SelectWithInfiniteScroller: FC<Props> = ({
    hasMore,
    onInfiniteScrollOnNextMemoised, //use usecallback here as this is used in debounced function
    onVisibilityChange,
    ...restProps
}) => {
    const rowElemRef = useRef<any>();

    function dropdownInfiniteScrollOnNext() {
        if (onInfiniteScrollOnNextMemoised) onInfiniteScrollOnNextMemoised();
    }

    //debounced infinite scroller function for dropdown
    const debouncedInfiniteScroller = useCallback(_.debounce(dropdownInfiniteScrollOnNext, 150), [
        onInfiniteScrollOnNextMemoised,
    ]);

    return (
        <Select
            id="infinite-scrollable-dropdown"
            {...restProps}
            onDropdownVisibleChange={(open: boolean) => {
                //scrolling to top on closing dropdown
                if (!open && rowElemRef.current) {
                    rowElemRef.current?.target?.scrollTo({ top: 0 });
                }
                if (onVisibilityChange) onVisibilityChange(open);
            }}
            onPopupScroll={(element) => {
                if (!rowElemRef.current) rowElemRef.current = element;
                const scrollHeight = element?.currentTarget?.scrollHeight; //total height
                const clientHeight = element?.currentTarget?.clientHeight; //viewport height
                const scrollBarBottomPosition = clientHeight + element?.currentTarget?.scrollTop;
                const threshold = 0.95;
                //only infinite scroll if current data length is less than total meta data
                if (scrollBarBottomPosition >= scrollHeight * threshold && hasMore) {
                    // trigger infinite scroller function
                    debouncedInfiniteScroller();
                    // debouncedInfiniteScroller(attributeNamesLoading);
                }
            }}
        />
    );
};

export default SelectWithInfiniteScroller;
